<template>
    <Tabs v-model="active">
        <Tab title="列表" name="list">
            <ListTab @onSelect="onSelected"/>
        </Tab>
        <Tab title="层级" name="tree">
            <TreeTab @onSelect="onSelected"/>
        </Tab>
    </Tabs>
</template>

<script>
    import {Tab, Tabs} from "vant"
    import ListTab from "./components/ListTab"
    import TreeTab from "./components/TreeTab"

    export default {
        components: {Tabs, Tab, ListTab, TreeTab},
        data() {
            return {active: 'list', selected: null}
        },
        mounted() {
        },
        methods: {
            onSelected(data) {
                const {type} = data
                if ('Unit' === type) {
                    this.selected = data
                    this.$store.dispatch({type: 'default/setDefault', payload: {organ: null, unit: data, area: null}})
                        .then(this.selectAfter)
                } else if ('Organs' === type) {
                    this.selected = data
                    this.$store.dispatch({type: 'default/setDefault', payload: {organ: data, unit: null, area: null}})
                        .then(this.selectAfter)
                }

            },
            selectAfter() {
                this.$toast.success('切换成功')
                this.$store.dispatch({type: 'global/init', payload: {unit: this.selected}})
                setTimeout(() => this.$router.replace("/"), 1000)

            }
        }
    }
</script>

<style scoped>

</style>